import React, { ReactNode } from 'react';

interface EmptyStateBoxProps {
  icon: ReactNode;
  text: string;
  bgColor: string;
  borderColor: string;
  iconBgColor: string;
  iconColor: string;
}

export function EmptyStateBox({
  icon,
  text,
  bgColor,
  borderColor,
  iconBgColor,
  iconColor
}: EmptyStateBoxProps) {
  return (
    <div className={`text-center py-10 ${bgColor}  border-2 border-dashed ${borderColor} shadow-inner`}>
      <div className={`flex-shrink-0 h-16 w-16 mx-auto rounded-full ${iconBgColor} flex items-center justify-center mb-4`}>
        <div className={`${iconColor}`}>
          {icon}
        </div>
      </div>
      <p className="font-medium text-lg">
        {text}
      </p>
    </div>
  );
} 